import { isFeature } from 'Cloud/Application/FeaturesEs6';

// CLOUDWEB-18894
// Зажим на кнопку Выделить все в чистилке
export const overquotaClearAbSelectAll: boolean | undefined = isFeature('overquota-clear-ab-selectall');
